import React, { useEffect, useState } from 'react';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import InputField from '../../jsx/components/fields/inputField';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import { useDispatch, useSelector } from 'react-redux';
import { createPaymentMethod } from '../../service/api/paymentGateway/createPaymentMethod';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import ResponceForAPI from '../../component/backDrop/responcesForAPI';
import creditCardType from 'credit-card-type';
import validator, { isPostalCode } from 'validator';
import { userById } from '../../service/api/user/userById';
import { setUserDetails } from '../../feature/userData/userData';
import { getPaymentMethodListByCustomerId } from '../../service/api/paymentGateway/getPaymentMethodListByCustomerId';
import './saveCardDetails.scss'
import UpdateCardDetails from './updateCardDetails';
import { Card, Modal, OverlayTrigger, Popover, Spinner, Tooltip } from 'react-bootstrap';
import AddNewCard from './addNewCard';
import DeleteCard from './deleteCard';
import setDefaultPaymentMethodById from '../../service/api/paymentGateway/setDefaultPaymentMethodById';
import SkeletonDivElement from '../../component/skeletonTableRow/skeletonDivElement';
import { getPaymentMethodSupportedList } from '../../service/api/paymentGateway/getPaymentMethodSupportedList';
import { getSubscriptionTransactionList } from '../../service/api/paymentGateway/getSubscriptionTransactionList';
import { getCallLogTransactionList } from '../../service/api/paymentGateway/getCallLogTransactionList';
import { Elements, CardElement, useStripe, useElements, CardNumberElement } from '@stripe/react-stripe-js';
import { CardNumberInput, CardExpiryInput, CardCvcInput } from './cardElements/cardInput';
import axios from 'axios';
import StandardInputField from '../../jsx/components/fields/standardInputField';


function SaveCardDetails() {
    const { paymentMethodID, customerID, impersonateFlag, permissionArr, role } = useSelector((state) => state.user);

    const dispatch = useDispatch();

    const permissionArray = permissionArr[0] || []

    const [cardInfo, setCardInfo] = useState({
        cardNumber: '',
        expiryDate: '',
        cvc: '',
        cardHolder: '',
        focus: '',
    });
    const [isCardHolderNameErr, setIsCardHolderNameErr] = useState(false);
    const [isCardNumberErr, setIsCardNumberErr] = useState(false);
    const [isCardExpErr, setIsCardExpErr] = useState(false);
    const [isCardCVCErr, setIsCardCVCErr] = useState(false);

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);
    const [apiResponce, setApiResponse] = useState(false);

    const [supportedPaymentMethodsArr, setSupportedPaymentMethodsArr] = useState([]);
    const [customLoadingForSupportedMethods, setCustomLoadingForSupportedMethods] = useState(false);
    const [getSupportedPaymentFlag, setGetSupportedPaymentFlag] = useState(false);

    const [formatedNumber, setFormatedNumber] = useState("");

    const [myCountryCode, setMyCountryCode] = useState('US');

    // Add new Payment method modal functions
    const [addNewPaymentMethodTrigger, setAddNewPaymentMethodTrigger] = useState(false);
    const handleCloseAddNewPaymentMethod = () => {
        setAddNewPaymentMethodTrigger(false);
        // handleClearCardStates();
    }
    const handleOpenAddNewPaymentMethod = () => {
        setAddNewPaymentMethodTrigger(true);
        setGetSupportedPaymentFlag(true);
    }

    // Add new card modal functions
    const [addCardFirstTimeTrigger, setAddCardFirstTimeTrigger] = useState(false);
    const handleCloseAddCardFirstTime = () => {
        setAddCardFirstTimeTrigger(false);
        handleClearCardStates();
    }
    const handleOpenAddCardFirstTime = () => {
        setAddCardFirstTimeTrigger(true);
    }

    const handleClearCardStates = () => {
        setCardInfo({
            cardNumber: '',
            expiryDate: '',
            cvc: '',
            cardHolder: '',
            focus: '',
        })
        setFormatedNumber('')
        setIsCardHolderNameErr(false)
        setIsCardNumberErr(false)
        setIsCardExpErr(false)
        setIsCardCVCErr(false)

        setCardCvcError('')
        setCardExpiryError('')
        setCardNumberError('')

        setZipCode('')
        setIsZipCodeErr(false)
    }



    // Tooltips here
    const tooltipUpdate = (
        <Tooltip id="tooltip" >
            <strong >Update</strong>
        </Tooltip>
    );
    const tooltipDelete = (
        <Tooltip id="tooltip" >
            <strong >Delete</strong>
        </Tooltip>
    );

    const handleCardNumberChange = (e) => {
        setIsCardNumberErr(false);
        // Remove anything that's not a digit
        const newValue = e.target.value?.replace(/\D/g, '');

        // Add spaces after every 4 digits for display
        const formattedValue = newValue?.replace(/(\d{4})/g, '$1 ').trim();

        // Update the actual input value
        e.target.value = formattedValue;

        setFormatedNumber(formattedValue)

        // Update state without spaces
        setCardInfo({
            ...cardInfo,
            cardNumber: newValue
        });
    };

    const handleExpiryDateChange = (e) => {
        setIsCardExpErr(false);
        let value = e.target.value?.replace(/\D/g, '');
        if (value.length > 4) value = value.substr(0, 4); // Maximum length of 4 digits
        if (value.length > 2) value = value.substr(0, 2) + '/' + value.substr(2); // Insert slash after two digits

        setCardInfo({
            ...cardInfo,
            expiryDate: value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'cardHolder') {
            setIsCardHolderNameErr(false)
        }

        setCardInfo({
            ...cardInfo,
            [name]: value
        });
    };

    const handleCVCChange = (e) => {
        setIsCardCVCErr(false)
        const newValue = e.target.value?.replace(/\D/g, ''); // Remove non-digit characters
        setCardInfo({
            ...cardInfo,
            cvc: newValue
        });
    };

    const handleInputFocus = (e) => {
        const { name } = e.target;
        setCardInfo({
            ...cardInfo,
            focus: name
        });
    };

    const handleCardHolderNameBlurCheck = () => {
        if (cardInfo.cardHolder.trim() === '') {
            setIsCardHolderNameErr(true);
        }
    }

    const handleCardNumberBlurCheck = () => {
        // console.log(!validateCardNumber(Number(cardInfo.cardNumber)))
        // console.log(cardInfo.cardNumber, typeof cardInfo.cardNumber, 'handleCardNumberBlurCheck')

        const cardType = creditCardType(cardInfo.cardNumber);
        // console.log(cardType, 'cardType')

        if (cardInfo?.cardNumber?.length !== 16 || cardType?.length === 0
            // || !validator.isCreditCard(cardInfo.cardNumber)
        ) {
            setIsCardNumberErr(true);
        }
    }

    const handleCardExpBlurCheck = () => {
        const [month, year] = cardInfo.expiryDate.split('/');
        if (cardInfo.expiryDate.trim() === ""
            || cardInfo?.expiryDate?.trim()?.length != 5
            || Number(month) > 12
            || Number(year) < Number((new Date()).getFullYear().toString().slice(-2))) {
            setIsCardExpErr(true);
        }
    }

    const handleCardCVCBlurCheck = () => {
        if (cardInfo?.cvc?.length < 3 || cardInfo?.cvc?.trim() === "") {
            setIsCardCVCErr(true);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setApiResponse(true);
        const [month, year] = cardInfo.expiryDate.split('/');
        if (cardInfo.cardHolder.trim() === '') {
            setIsCardHolderNameErr(true);
            setApiResponse(false);
        }
        const cardType = creditCardType(cardInfo.cardNumber);

        if (cardInfo?.cardNumber?.length !== 16 || cardType?.length === 0
            // || !validator.isCreditCard(cardInfo.cardNumber)
        ) {
            setIsCardNumberErr(true);
        }
        if (cardInfo.expiryDate.trim() === ""
            || cardInfo?.expiryDate?.trim()?.length != 5
            || Number(month) > 12
            || Number(year) < Number((new Date()).getFullYear().toString().slice(-2))) {
            setIsCardExpErr(true);
            setApiResponse(false);
        }
        if (cardInfo?.cvc?.length < 3 || cardInfo?.cvc?.trim() === "") {
            setIsCardCVCErr(true);
            setApiResponse(false);
        }

        if ((cardInfo?.cardHolder?.trim() === '') ||
            (cardInfo?.cardNumber?.length !== 16) ||
            (cardType?.length === 0) ||
            // !validator.isCreditCard(cardInfo.cardNumber) ||
            (cardInfo.expiryDate.trim() === ""
                || cardInfo?.expiryDate?.trim()?.length != 5
                || Number(month) > 12
                || Number(year) < Number((new Date()).getFullYear().toString().slice(-2))) ||
            (cardInfo?.cvc?.length < 3 || cardInfo?.cvc?.trim() === "")) {
            setApiResponse(false);
            return
        }

        if (!isCardHolderNameErr && !isCardNumberErr && !isCardExpErr && !isCardCVCErr) {
            // Here you can handle the submission of the credit card information.

            let details = new FormData();

            details.append("user_id_ids", localStorage.getItem("user_id"));
            details.append("name_on_card", cardInfo.cardHolder);
            details.append("card_number", parseInt(cardInfo.cardNumber));
            details.append("expiry_month", parseInt(month));
            details.append("expiry_year", parseInt(year));
            details.append("card_cvc_number", parseInt(cardInfo.cvc));
            details.append("token_chr", "tok_visa");

            dispatch(
                createPaymentMethod(
                    details,
                    (res) => {
                        // console.log(res)
                        setApiResponse(false);
                        setResponceMsg(res.data.message)
                        setToasterType("success")
                        handleCloseAddCardFirstTime();

                        getPaymentMethodList(res?.data?.data?.customer?.id);

                        let details = {
                            user_id_ids: localStorage.getItem('user_id'),
                            role_id_int: localStorage.getItem("roleId"),
                            user_impersonate_flag: 0
                        }
                        dispatch(
                            userById(details, (res) => {
                                dispatch(setUserDetails(res.data.data));
                            }),
                        )

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 11000);
                    },
                    (res) => {
                        // console.log(res)
                        setResponceMsg(res.data.message)
                        setToasterType("error");

                        setApiResponse(false);

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            )
        }
    };

    // const [lastFourDigitCard, setLastFourDigitCard] = useState('');
    // const [initialMonthExpCard, setInitialMonthExpCard] = useState('');
    // const [initialYearExpCard, setInitialYearExpCard] = useState('');
    // const [initialNameOnCard, setInitialNameOnCard] = useState('');
    // const [particularPaymentMethodId, setParticularPaymentMethodId] = useState('');


    const [cardArr, setCardArr] = useState([]);
    const [particularCard, setParticularCard] = useState({});

    const setInitialCardDetails = (res) => {
        // console.log(res.data[0]);
        setCardArr(res.data);

        // setParticularPaymentMethodId(res?.data[res?.data?.length - 1].id);
        // setInitialNameOnCard(res?.data[res?.data?.length - 1].billing_details?.name);
        // setLastFourDigitCard(`0000 0000 0000 ${res.data[res?.data?.length - 1].card.last4}`);
        // if (res?.data[res?.data?.length - 1].card?.exp_month < 10) {
        //     setInitialMonthExpCard(`0${res?.data[res?.data?.length - 1].card?.exp_month}`);
        // } else {
        //     setInitialMonthExpCard(res?.data[res?.data?.length - 1].card?.exp_month);
        // }
        // setInitialYearExpCard((res?.data[res?.data?.length - 1].card?.exp_year % 100)?.toString());
    }

    // console.log(cardArr, 'cardArr')

    useEffect(() => {
        if (customerID) {
            getPaymentMethodList();
        }
    }, [])

    useEffect(() => {
        if (!customerID) {
            const getCountryCode = async () => {
                try {
                    const response = await axios.get('https://ipapi.co/json/');
                    const data = response.data;
                    // console.log(`'My country code:', ${data.country}`)
                    setMyCountryCode(data.country);
                } catch (error) {
                    // console.log('Error fetching country code:', error);
                }
            };
            getCountryCode();
        }
    }, []);

    // Update card modal functions
    const [updateCardTrigger, setUpdateCardTrigger] = useState(false);
    const handleCloseUpdateCard = () => {
        setUpdateCardTrigger(false);
        getPaymentMethodList();
    }

    const handleOpenUpdateCard = (element, isPrimaryCard) => {
        setUpdateCardTrigger(true);
        if (isPrimaryCard) {
            setParticularCard(cardArr[cardArr?.length - 1])
        } else {
            setParticularCard(element)
        }
    }

    // Add new card modal functions
    const [addNewCardTrigger, setAddNewCardTrigger] = useState(false);
    const handleCloseAddNewCard = () => {
        setAddNewCardTrigger(false);
        getPaymentMethodList();
    }
    const handleOpenAddNewCard = () => {
        setAddNewCardTrigger(true);
    }

    // Delete card modal functions
    const [deleteCardTrigger, setDeleteCardTrigger] = useState(false);
    const handleCloseDeleteCard = () => {
        setDeleteCardTrigger(false);
        getPaymentMethodList()
    }

    const handleOpenDeleteCard = (element, isPrimaryCard) => {
        setDeleteCardTrigger(true);
        if (isPrimaryCard) {
            setParticularCard(cardArr[cardArr?.length - 1])
        } else {
            setParticularCard(element)
        }
    }

    const [customSkeletonLoading, setCustomSkeletonLoading] = useState(false);
    const getPaymentMethodList = (firstTimeID) => {

        let details = {
            customer_id_ids: customerID || firstTimeID,
        }
        setCustomSkeletonLoading(true);
        dispatch(
            getPaymentMethodListByCustomerId(details,
                (res) => {
                    // console.log(res.data.data)
                    setInitialCardDetails(res?.data?.data)
                    setCustomSkeletonLoading(false);
                },
                (res) => {
                    // console.log(res.data.data)
                    setCustomSkeletonLoading(false);
                })
        )

    }

    // Set default payment method
    const selectPrimaryCardFn = (e, element) => {
        e?.preventDefault();
        setApiResponse(true);
        let details = new FormData();

        details.append("payment_method_id", element.id);
        details.append("user_id_ids", localStorage.getItem("user_id"));

        dispatch(
            setDefaultPaymentMethodById(
                details,
                (res) => {
                    // console.log(res)
                    setApiResponse(false);
                    setResponceMsg(res.data.message)
                    setToasterType("success")

                    setActivePopoverCard(null)

                    getPaymentMethodList();
                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);

                },
                (res) => {
                    // console.log(res)
                    setResponceMsg(res.data.message)
                    setToasterType("error");

                    setApiResponse(false);

                    setActivePopoverCard(null)

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        )
    }

    // New Payments methods functions starts here
    const [cardObject, setCardObject] = useState({});
    const [activePopoverCard, setActivePopoverCard] = useState(null);

    const handleMenuClick = (element, index) => {
        setCardObject(element)
        setActivePopoverCard(activePopoverCard === index ? null : index)
    }

    const popover = (index) => (
        <Popover
            // id="popover-basic"
            id={`popover-basic-${index}`}

            //   className="custom-popover"
            style={{ minWidth: "100px", border: 'none' }}
        >
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",

                }}>
                <div className="d-flex flex-column font-w500 fs-6" style={{}}>
                    {!cardObject?.is_default_card &&
                        <div
                            onClick={(e) => {
                                selectPrimaryCardFn(e, cardObject);
                                // setActivePopoverCard(null)
                            }}
                            className='border-bottom cursor-pointer p-2  text-black overlay-action-btn d-flex align-items-center'
                            style={{
                                pointerEvents: apiResponce ? "none" : "auto",
                                opacity: apiResponce ? "0.5" : "1"
                            }}
                        >
                            <span className='me-2'>
                                {apiResponce ?
                                    <Spinner animation="border" size="sm" /> :
                                    <i className="bi bi-star"></i>
                                }
                            </span>
                            <span>{"Make primary"}</span>
                        </div>
                    }

                    <div
                        onClick={(e) => {
                            handleOpenUpdateCard(cardObject, false);
                            setActivePopoverCard(null)
                        }}
                        className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-pencil"></i>
                        </span>
                        <span>{"Edit card details"}</span>
                    </div>


                    <div
                        onClick={(e) => {
                            handleOpenDeleteCard(cardObject, false);
                            setActivePopoverCard(null)
                        }}
                        className=' cursor-pointer p-2 text-danger overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-trash"></i>
                        </span>
                        <span>{"Remove card"}</span>
                    </div>
                </div>
            </Popover.Body>
        </Popover>
    );

    const getPaymentMethodSupportedListFn = () => {
        let details = {}
        setCustomLoadingForSupportedMethods(true);
        dispatch(
            getPaymentMethodSupportedList(details,
                (res) => {
                    // console.log(res.data.data)
                    // console.log(res?.data?.data)
                    setSupportedPaymentMethodsArr(res?.data?.data)
                    setCustomLoadingForSupportedMethods(false);
                },
                (res) => {
                    // console.log(res.data.data)
                    setCustomLoadingForSupportedMethods(false);
                })
        )
    }

    useEffect(() => {
        if (getSupportedPaymentFlag) {
            getPaymentMethodSupportedListFn()
        }
    }, [getSupportedPaymentFlag])

    // View payment history functions
    const [viewPaymentHistoryTrigger, setViewPaymentHistoryTrigger] = useState(false);
    const [viewpaymentHistoryFlag, setViewpaymentHistoryFlag] = useState(false);
    const [paymentHistoryArrPro, setPaymentHistoryArrPro] = useState([]);
    const [paymentHistoryArrCust, setPaymentHistoryArrCust] = useState([]);
    const [paymentHistoryLoading, setPaymentHistoryLoading] = useState(false);
    const handleOpenViewPaymentHistory = () => {
        setViewPaymentHistoryTrigger(true);
        setViewpaymentHistoryFlag(true);
    }
    const handleCloseViewPaymentHistory = () => {
        setViewPaymentHistoryTrigger(false);
    }

    function getSubscriptionTransactionListFn() {
        setPaymentHistoryLoading(true)
        // let details = {};
        let details = new FormData();
        details.append("status_chr", 'all');
        dispatch(
            getSubscriptionTransactionList(details, (res) => {
                setPaymentHistoryLoading(false)
                // console.log(res.data.data);
                setPaymentHistoryArrPro(res.data.data)


            }, (err) => {
                setPaymentHistoryLoading(false)
                // console.log(err);
            })
        )
    }

    const getCallLogTransactionListFn = () => {
        setPaymentHistoryLoading(true)
        let data = {
            current_date: Math.floor(Date.now() / 1000),
            filter_type: '',
        }
        dispatch(
            getCallLogTransactionList(data,
                (res) => {
                    setPaymentHistoryLoading(false)
                    // console.log(res.data.data);
                    setPaymentHistoryArrCust(res.data.data)
                },
                (res) => {
                    setPaymentHistoryLoading(false)
                    // console.log(res)
                })
        )
    }

    // useEffect(() => {
    //     if (viewpaymentHistoryFlag) {

    //     }
    // }, [viewpaymentHistoryFlag]);

    function viewPaymentHistory() {
        handleOpenViewPaymentHistory()
        if (permissionArray.includes("UPDATE WORK INFORMATION")) {
            getSubscriptionTransactionListFn();
        }
        if (permissionArray.includes("SCAN TAB")) {
            getCallLogTransactionListFn();
        }
    }

    function convertUnixTime(unixTime) {
        // Create a new Date object from the Unix timestamp
        // Note: Unix timestamp should be in milliseconds for JavaScript Date object,
        // so we multiply by 1000 (because Unix timestamp is usually in seconds).
        const date = new Date(unixTime * 1000);

        // Define an array of month names to convert month number to month name
        const months = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        // Extract the day, month and year from the date
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();

        // Return the formatted date string
        return `${month} ${day}, ${year}`;
    }

    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const stripe = useStripe();
    const elements = useElements();

    const handleSubmitStripe = async (event) => {
        event.preventDefault();
        setApiResponse(true);

        const isValidZipCode = validateZipCode();

        if (cardInfo.cardHolder.trim() === '' || !isValidZipCode) {
            if (cardInfo.cardHolder.trim() === '') {
                setIsCardHolderNameErr(true);
                setApiResponse(false);
            }

            // if (zipCode.trim() === '') {
            //     setIsZipCodeErr(true);
            //     setApiResponse(false);
            // }

        } else {
            if (!stripe || !elements) {
                // Ensure Stripe.js has loaded
                // console.log('Stripe has not loaded yet');
                setApiResponse(false);

                setResponceMsg('Stripe has not loaded yet')
                setToasterType("error");
                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);

                return;
            }

            // const cardElement = elements.getElement(CardElement);
            const cardElement = elements.getElement(CardNumberElement);


            // const cardNumberElement = elements.getElement(CardNumberInput);
            // const cardExpiryElement = elements.getElement(CardExpiryInput);
            // const cardCvcElement = elements.getElement(CardCvcInput);

            const { error, token } = await stripe.createToken(cardElement, {
                address_zip: zipCode,
            });

            if (error) {
                // console.log('Error:', error.message);
                setApiResponse(false);

                // setResponceMsg(error.message)
                // setToasterType("error");
                // setHandleToaster(true);
                // setTimeout(() => {
                //     setHandleToaster(false);
                // }, 2000);

            } else {
                // console.log('Success! Token: ', token);
                // console.log('Token created:', token.id);
                // You can now send the token to your server

                let details = new FormData();

                details.append("user_id_ids", localStorage.getItem("user_id"));
                details.append("name_on_card", cardInfo.cardHolder);
                details.append("token_chr", token.id);
                details.append("zip_code_chr", zipCode);
                details.append("country_code_chr", myCountryCode);

                setApiResponse(true);

                dispatch(
                    createPaymentMethod(
                        details,
                        (res) => {
                            // console.log(res)
                            setApiResponse(false);

                            setResponceMsg(res.data.message)
                            setToasterType("success")

                            handleCloseAddCardFirstTime();

                            getPaymentMethodList(res?.data?.data?.customer?.id);

                            let details = {
                                user_id_ids: localStorage.getItem('user_id'),
                                role_id_int: localStorage.getItem("roleId"),
                                user_impersonate_flag: 0
                            }
                            dispatch(
                                userById(details, (res) => {
                                    dispatch(setUserDetails(res.data.data));
                                }),
                            )

                            // setHandleToaster(true);
                            // setTimeout(() => {
                            //     setHandleToaster(false);
                            // }, 11000);
                        },
                        (res) => {
                            // console.log(res)
                            setResponceMsg(res.data.message)
                            setToasterType("error");

                            setApiResponse(false);

                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }
                    )
                )
            }
        }



    }

    const [cardNumberError, setCardNumberError] = useState('');
    const [cardExpiryError, setCardExpiryError] = useState('');
    const [cardCvcError, setCardCvcError] = useState('');

    const handleCardNumberChangeStripe = (event) => {
        // setCardNumberError(event.error ? event.error.message : '');
        setCardNumberError(event.error ? 'Enter valid card number' : '');
    };

    const handleCardExpiryChangeStripe = (event) => {
        // setCardExpiryError(event.error ? event.error.message : '');
        setCardExpiryError(event.error ? 'Enter valid exp. date' : '');

    };

    const handleCardCvcChangeStripe = (event) => {
        // setCardCvcError(event.error ? event.error.message : '');
        setCardCvcError(event.error ? 'Enter valid cvc' : '');
    };

    const [zipCode, setZipCode] = useState("");
    const [isZipCodeErr, setIsZipCodeErr] = useState(false);
    const handleZipCode = (e) => {
        // setZipCode(e.target.value.replace(/\D/g, ''))
        setZipCode(e.target.value)
        setIsZipCodeErr(false)
    }

    const handleZipCodeBlurCheck = () => {
        // if (zipCode.trim() === '') {
        //     setIsZipCodeErr(true);
        // }
        validateZipCode();
    }

    const validateZipCode = () => {
        if (!zipCode) {
            setIsZipCodeErr(true);
            setApiResponse(false);
            return false;
        } else if (!isPostalCode(zipCode, myCountryCode || 'any')) {
            setIsZipCodeErr(true);
            setApiResponse(false);
            return false;
        }
        setIsZipCodeErr(false);
        return true;
    };

    return (
        <>
            {/* Pay credit card */}
            <Card className='border  card w-100 bg-white' style={{ minHeight: '350px' }}>
                <div className='row mx-0  w-100 h-100'>
                    <div className='col-12 d-flex flex-column justify-content-between lh-lg p-4' style={{}}>
                        <div>
                            <div className='row mx-0'>
                                <div className='align-items-center col-12 d-flex fs-3 fw-bold justify-content-center px-0'>
                                    <span className='align-items-center border d-flex fs-4 justify-content-center me-2 rounded-circle' style={{ height: '25px', width: '25px' }}>
                                        <i class="bi bi-currency-dollar"></i>
                                    </span>
                                    <span>{"Pay"}</span>
                                </div>
                            </div>

                            <div className='row mx-0 pb-2'>
                                <div className='align-items-center col-12 d-flex font-w500 justify-content-center px-0 text-black'>
                                    <span>{"Your payment methods"}</span>
                                </div>
                            </div>

                            <div className='row mx-0'>
                                <div className='col-12 px-0'>

                                    {customSkeletonLoading ?
                                        <>
                                            <SkeletonDivElement height={'80px'} marginBottom={'10px'} borderRadius={'0px'} />

                                            <SkeletonDivElement height={'80px'} marginBottom={'10px'} borderRadius={'0px'} />
                                        </> :
                                        <>
                                            {cardArr?.length > 0 ?
                                                <>
                                                    {/* Credit Cards list */}
                                                    {cardArr.map((element, index) => (
                                                        <div className='row mx-0' key={index}>
                                                            <div className='bg-white border col-12 mb-2 p-3 shadow-sm'>
                                                                <div className='row mx-0'>
                                                                    <div className='col-12  px-0 d-flex justify-content-between align-items-center'>
                                                                        {element.is_default_card ? <div className='font-w600 mb-1 row text-success'>
                                                                            {element.is_default_card && <span>{"Primary payment method"}</span>}
                                                                        </div> :
                                                                            <>
                                                                                <div className='d-flex fs-5 fw-bold text-black'>
                                                                                    <span>{`${(element?.card?.brand)?.toUpperCase()} – *${element?.card?.last4}`}</span>
                                                                                </div>
                                                                            </>
                                                                        }

                                                                        <div className='fs-5 fw-bold mb-1'>

                                                                            <div className="tooltipCustom">
                                                                                <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"More"}</span>
                                                                                <span
                                                                                    className='d-flex align-items-center justify-content-center more-option rounded-circle'
                                                                                    style={{ height: '20px', width: '20px' }}
                                                                                    onClick={() => { handleMenuClick(element, index) }}
                                                                                >
                                                                                    <OverlayTrigger
                                                                                        key={index}
                                                                                        trigger="click"
                                                                                        placement="bottom"
                                                                                        // overlay={popover}
                                                                                        overlay={popover(index)}
                                                                                        rootClose={true}
                                                                                        show={activePopoverCard === index}
                                                                                        onToggle={(show) => setActivePopoverCard(show ? index : null)}
                                                                                    >
                                                                                        <i class="bi bi-three-dots-vertical cursor-pointer"></i>
                                                                                    </OverlayTrigger>
                                                                                </span>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>

                                                                {element.is_default_card &&
                                                                    <div className='row mx-0'>
                                                                        <div className='col-12  px-0'>
                                                                            <div className='d-flex fs-5 fw-bold text-black'>
                                                                                <span>{`${(element?.card?.brand)?.toUpperCase()} – *${element?.card?.last4}`}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }


                                                                <div className='row mx-0'>
                                                                    <div className='col-12  px-0 d-flex justify-content-between align-items-center'>
                                                                        <div className='d-flex fs-6 font-w500 '>
                                                                            <span>{`${element?.billing_details?.name}`}</span>
                                                                        </div>

                                                                        <div className='d-flex fs-6 font-w500 '>
                                                                            <span>{`${element?.card?.exp_month}/${element?.card?.exp_year}`}</span>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </> :
                                                <div className='d-flex align-items-center justify-content-center'>
                                                    <span className='text-center'>{"You haven't added any payment methods yet. Start by adding a new one."}</span>
                                                </div>
                                            }
                                        </>
                                    }
                                </div>
                            </div>





                        </div>

                        <div className='row mx-0 pt-5 '>
                            <div className='col-12 px-0'>
                                <div className='row mx-0'>
                                    <div className='col-8  px-0'>
                                        <div className='d-flex'>
                                            {false && <>
                                                {!customerID ?
                                                    <div onClick={() => { handleOpenAddCardFirstTime() }} className='align-items-center  font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-2'>
                                                        <span>{"Add a new payment method"} </span>
                                                        {/* <i className="bi bi-chevron-right ps-2 hovered-arrow"></i> */}
                                                    </div> :
                                                    <div onClick={() => { handleOpenAddNewCard() }} className='align-items-center  font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-2'>
                                                        <span>{"Add a new payment method"} </span>
                                                        {/* <i className="bi bi-chevron-right ps-2 hovered-arrow"></i> */}
                                                    </div>
                                                }
                                            </>}

                                            <div onClick={() => { handleOpenAddNewPaymentMethod() }} className='align-items-center  font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-2'>
                                                <span>{"Add a new payment method"} </span>
                                                {/* <i className="bi bi-chevron-right ps-2 hovered-arrow"></i> */}
                                            </div>

                                        </div>
                                    </div>
                                    <div className='col-4'></div>
                                </div>

                                {/* <div className='row mx-0'>
                                    <div className='col-8  px-0'>
                                        <div className='d-flex'>
                                            <div onClick={viewPaymentHistory} className='align-items-center  font-w500 rounded-1 cursor-pointer d-flex overlay-action-btn px-2'>
                                                <span>{"View payment history"} </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-4'></div>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>
            </Card>


            {/* Modal to add new payment methods */}
            <Modal className="fade" show={addNewPaymentMethodTrigger} centered>
                <Modal.Body>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => handleCloseAddNewPaymentMethod()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                        <span>
                                            {"Payment methods"}
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0 mb-2'>
                                    <div className={`col-12 px-0 text-center`}>
                                        <span className='font-w600 fs-5'>
                                            {supportedPaymentMethodsArr.length > 0 ? "You can add a new payment method" : "No payment method available"}
                                        </span>
                                    </div>
                                </div>


                                {customLoadingForSupportedMethods ?
                                    <>
                                        <SkeletonDivElement height={'80px'} marginBottom={'10px'} borderRadius={'0px'} />
                                        <SkeletonDivElement height={'80px'} marginBottom={'10px'} borderRadius={'0px'} />
                                        <SkeletonDivElement height={'80px'} marginBottom={'10px'} borderRadius={'0px'} />
                                    </> :
                                    <>
                                        {supportedPaymentMethodsArr.length > 0 &&
                                            <div>
                                                {supportedPaymentMethodsArr.map((element, index) => {
                                                    return (
                                                        <>
                                                            <div
                                                                key={index}
                                                                className='row mx-0 border shadow-sm p-3 mb-2 overlay-action-btn cursor-pointer'
                                                                style={{
                                                                    pointerEvents: element?.is_active_ysn ? 'auto' : 'none',
                                                                    opacity: element?.is_active_ysn ? 1 : 0.5,
                                                                }}
                                                                onClick={() => {
                                                                    handleCloseAddNewPaymentMethod();
                                                                    !customerID ? handleOpenAddCardFirstTime() : handleOpenAddNewCard();
                                                                }}
                                                            >
                                                                <div className={`col-12 d-flex align-items-center`}>
                                                                    <div className='align-items-cente bg-light border d-flex fs-3 justify-content-center rounded-circle text-black'
                                                                        style={{ height: '35px', width: '35px', }}
                                                                    >
                                                                        <i class="align-self-center bi bi-gear-wide-connected"></i>
                                                                    </div>

                                                                    <div className='fs-4 font-w600 ps-3 text-black'>
                                                                        <span>
                                                                            {element?.name_chr}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })}

                                            </div>
                                        }
                                    </>
                                }



                            </>



                        </div>
                    </div>

                </Modal.Body>
            </Modal>


            {/* Modal to add new credit card first time */}
            <Modal className="fade" show={addCardFirstTimeTrigger} centered>
                <Modal.Body>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => handleCloseAddCardFirstTime()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                        <span>
                                            {"Add new card"}
                                        </span>
                                    </div>
                                </div>

                                <>
                                    <form onSubmit={handleSubmitStripe}>


                                        <div>
                                            {/* <CardInput /> */}

                                            <div className='row mx-0'>
                                                <div className='col-12 px-0'>
                                                    <label className={`font-w600 mb-1 ${cardNumberError ? 'text-red' : ''}`}>Card Number *</label>
                                                    <div
                                                        style={{
                                                            padding: '10px',
                                                            border: cardNumberError ? '1px solid red' : '1px solid #DBDBDB',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <CardNumberInput onChange={handleCardNumberChangeStripe} autocomplete="off" />
                                                    </div>
                                                    {cardNumberError && <div className="text-red fs-12">{cardNumberError}</div>}
                                                </div>
                                            </div>

                                            <div className='row mx-0 mt-2'>
                                                <div className='col-6 pe-2'>
                                                    <label className={`font-w600 mb-1 ${cardExpiryError ? 'text-red' : ''}`}>Expiry date *</label>
                                                    <div
                                                        style={{
                                                            padding: '10px',
                                                            border: cardExpiryError ? '1px solid red' : '1px solid #DBDBDB',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <CardExpiryInput onChange={handleCardExpiryChangeStripe} />
                                                    </div>
                                                    {cardExpiryError && <div className="text-red fs-12">{cardExpiryError}</div>}
                                                </div>

                                                <div className='col-6 ps-2'>
                                                    <label className={`font-w600 mb-1 ${cardCvcError ? 'text-red' : ''}`}>CVC *</label>
                                                    <div
                                                        style={{
                                                            padding: '10px',
                                                            border: cardCvcError ? '1px solid red' : '1px solid #DBDBDB',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <CardCvcInput onChange={handleCardCvcChangeStripe} />
                                                    </div>
                                                    {cardCvcError && <div className="text-red fs-12">{cardCvcError}</div>}
                                                </div>
                                            </div>

                                            <div className='row mx-0 mt-3'>
                                                <div className='col-12 px-0'>
                                                    <StandardInputField
                                                        labelName="Name on card"
                                                        placeholderName={'Name on card'}
                                                        type={'text'}
                                                        name={'cardHolder'}
                                                        value={cardInfo.cardHolder}
                                                        onChange={handleInputChange}
                                                        onFocus={handleInputFocus}
                                                        onBlur={handleCardHolderNameBlurCheck}
                                                        errorOccured={isCardHolderNameErr}
                                                        errorMeesage={'Enter valid cardholder name'}
                                                        isRequired={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className='row mx-0'>
                                                <div className='col-12 px-0'>
                                                    <StandardInputField
                                                        labelName={"Zip code"}
                                                        placeholderName={'Zip code'}
                                                        value={zipCode}
                                                        onChange={(e) => { handleZipCode(e) }}
                                                        onBlur={() => { handleZipCodeBlurCheck() }}
                                                        errorOccured={isZipCodeErr}
                                                        errorMeesage={`Enter valid zip code`}
                                                        isRequired={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className='col-12 px-0  mt-2'>
                                                <PrimaryButton
                                                    onClick={(e) => handleSubmitStripe(e)}
                                                    buttonName={"ADD NEW CARD"}
                                                    type={"submit"}
                                                    loadingMessage={"LOADING..."}
                                                    isLoading={apiResponce}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, rgb(22, 186, 78) 1.99%, rgb(25, 223, 92) 99.97%)',
                                                        border: 'none',
                                                        boxShadow: 'rgba(45, 204, 99, 0.24) 0px 6px 12px 0px',
                                                    }}
                                                    disabled={!stripe}
                                                />
                                            </div>

                                        </div>

                                    </form>
                                </>
                                {/* <>
                                    <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>

                                        <div className='row mx-0'>
                                            <div className={`col-12 px-0 `}>
                                                <InputField
                                                    labelName="Card number"
                                                    placeholderName={'1234 1234 1234 1234'}
                                                    type={'text'}
                                                    name={'cardNumber'}
                                                    value={formatedNumber}
                                                    onChange={handleCardNumberChange}
                                                    onFocus={handleInputFocus}
                                                    maxLength={19}
                                                    onBlur={handleCardNumberBlurCheck}
                                                    errorOccured={isCardNumberErr}
                                                    errorMeesage={'Enter valid card number'}
                                                />
                                            </div>
                                        </div>

                                        <div className='row mx-0 justify-content-between'>
                                            <div className='col-6 px-0 pe-2'>
                                                <InputField
                                                    labelName="MM/YY"
                                                    placeholderName={'MM/YY'}
                                                    type={'text'}
                                                    name={'expiryDate'}
                                                    value={cardInfo.expiryDate}
                                                    onChange={handleExpiryDateChange}
                                                    onFocus={handleInputFocus}
                                                    onBlur={handleCardExpBlurCheck}
                                                    errorOccured={isCardExpErr}
                                                    errorMeesage={'Enter valid exp. date'}
                                                />
                                            </div>

                                            <div className='col-6 px-0  ps-2'>
                                                <InputField
                                                    labelName="CVV"
                                                    placeholderName={'CVV'}
                                                    type={'text'}
                                                    name={'cvc'}
                                                    value={cardInfo.cvc}
                                                    onChange={handleCVCChange}
                                                    onFocus={handleInputFocus}
                                                    onBlur={handleCardCVCBlurCheck}
                                                    errorOccured={isCardCVCErr}
                                                    errorMeesage={'Enter valid cvc'}
                                                    maxLength={4}
                                                />
                                            </div>

                                        </div>




                                        <div className='row mx-0'>
                                            <div className='col-12 px-0'>
                                                <InputField
                                                    labelName="Name on card"
                                                    placeholderName={'Cardholder Name'}
                                                    type={'text'}
                                                    name={'cardHolder'}
                                                    value={cardInfo.cardHolder}
                                                    onChange={handleInputChange}
                                                    onFocus={handleInputFocus}
                                                    onBlur={handleCardHolderNameBlurCheck}
                                                    errorOccured={isCardHolderNameErr}
                                                    errorMeesage={'Enter valid cardholder name'}
                                                />
                                            </div>
                                        </div>

                                        <div className='row mx-0 justify-content-between mt-2'>
                                            <div className='col-12 px-0 mb-2'>
                                                <PrimaryButton
                                                    onClick={(e) => handleSubmit(e)}
                                                    buttonName={"Add new card"}
                                                    type={"submit"}
                                                    loadingMessage={"Loading..."}
                                                    isLoading={apiResponce}
                                                    style={{ width: "100%", background: 'green', border: 'none' }}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </> */}
                            </>



                        </div>
                    </div>

                </Modal.Body>
            </Modal>

            {/* Modal for view payment history */}
            <Modal className="fade" show={viewPaymentHistoryTrigger} centered>
                <Modal.Body style={{ minHeight: '40dvh', maxHeight: '70dvh' }}>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => handleCloseViewPaymentHistory()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4 pb-2 border-bottom'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                        <span>
                                            {"Payment history"}
                                        </span>
                                    </div>
                                </div>

                                {/* View payment history for pro */}
                                {permissionArray.includes("UPDATE WORK INFORMATION") &&
                                    <div className='h-100 overflow-auto' style={{ maxHeight: '50dvh' }}>

                                        {paymentHistoryLoading ?
                                            <>
                                                <SkeletonDivElement height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                                <SkeletonDivElement height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                                <SkeletonDivElement height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                                <SkeletonDivElement height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                            </> : <>
                                                {paymentHistoryArrPro.length > 0 ?
                                                    <>
                                                        {
                                                            paymentHistoryArrPro.map((element, index) => {
                                                                return (
                                                                    <>
                                                                        <div key={index} className='row mx-0 border-bottom py-3'>
                                                                            <div className='col-12 px-0'>
                                                                                <div className='row align-items-center mx-2 mb-1'>
                                                                                    <div className='col-4'>
                                                                                        <span className='font-w500'>{`${convertUnixTime(element?.created_date_dtm)}`}</span>
                                                                                    </div>

                                                                                    <div className='col-6'>
                                                                                        <span className='font-w500 text-black'>{`${element?.payment_method_meta_data?.card?.brand?.toUpperCase()} - *${element?.payment_method_meta_data?.card?.last4}`}</span>
                                                                                    </div>

                                                                                    <div className='col-2 d-flex justify-content-end'>
                                                                                        {/* <span className='font-w500 text-black'>{`${USDollar.format(element?.subscription_invoice_meta_data?.amount_paid / 100)}`}</span> */}
                                                                                        <span className='font-w500 text-black'>{`${USDollar.format(element?.payment_intent_meta_data?.amount / 100)}`}</span>
                                                                                    </div>

                                                                                </div>

                                                                                <div className='row mx-2 p-3 bg-light'>
                                                                                    <div className='col-12 px-0 mb-1'>
                                                                                        <span className='font-w500 text-black'>{`${(element?.payment_intent_meta_data?.description)}`}</span>
                                                                                    </div>

                                                                                    <div className='col-12 px-0'>
                                                                                        <span>{`Time period: `}</span>
                                                                                        <span>{`${convertUnixTime(element?.subscription_invoice_meta_data?.lines?.data[0]?.period?.start)} - `}</span>
                                                                                        <span>{`${convertUnixTime(element?.subscription_invoice_meta_data?.lines?.data[0]?.period?.end)}`}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            })
                                                        }

                                                    </>
                                                    :
                                                    <div className='row mx-0 h-100'>
                                                        <div className='col-12 px-0 h-100 d-flex justify-content-center align-items-center'>
                                                            <span>
                                                                {"No payment history"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                            </>}
                                    </div>
                                }

                                {/* View payment history for customer */}
                                {permissionArray.includes("SCAN TAB") &&
                                    <>
                                        <div className='mx-0 row border-bottom pb-2'>
                                            <div className='col-12 px-0'>
                                                <span>{`${paymentHistoryArrCust.length} transaction`}</span>
                                            </div>
                                        </div>
                                        <div className='h-100 overflow-auto' style={{ maxHeight: '50dvh' }}>
                                            {paymentHistoryLoading ?
                                                <>
                                                    <SkeletonDivElement height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                                    <SkeletonDivElement height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                                    <SkeletonDivElement height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                                    <SkeletonDivElement height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                                </> :
                                                <>
                                                    {paymentHistoryArrCust.length > 0 ?
                                                        <>
                                                            {
                                                                paymentHistoryArrCust.map((element, index) => {
                                                                    return (
                                                                        <>
                                                                            <div key={index} className='row mx-0 border-bottom py-3'>
                                                                                <div className='col-12 px-0'>
                                                                                    <div className='row mx-2 mb-1'>
                                                                                        <div className='col-12 px-0 d-flex justify-content-between align-items-center'>
                                                                                            <div className='font-w500 text-black'>
                                                                                                {/* <span>{`A ${(element?.call_duration_in_second / 60).toFixed(2)} minute video call costs ${USDollar.format(element?.payment_intent_meta_data?.amount_received / 100)}.`}</span> */}
                                                                                                <span>{`${element?.payment_intent_meta_data?.description}`}</span>
                                                                                            </div>

                                                                                            <div className='font-w600 text-black'>
                                                                                                {/* <span>{`${USDollar.format(Object.keys(element?.payment_to_pro_meta_data).length > 0 ? (element?.payment_to_pro_meta_data?.amount / 100) : 0)}`}</span> */}
                                                                                                <span>{`${USDollar.format(element?.payment_intent_meta_data?.amount_received ? (element?.payment_intent_meta_data?.amount_received / 100) : 0)}`}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className='row mx-2'>
                                                                                        <div className='col-12 px-0 mb-1 d-flex justify-content-between align-items-center'>
                                                                                            <div>
                                                                                                <span>{`${convertUnixTime(element?.created_date_dtm)}`}</span>
                                                                                            </div>

                                                                                            <div>
                                                                                                {/* <span>{`Platform fee `}</span>
                                                                                                <span className='font-w600 text-black'>{`${USDollar.format(Object.keys(element?.platform_fee_meta_data).length > 0 ? (element?.platform_fee_meta_data?.amount / 100) : 0)}`}</span> */}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })
                                                            }

                                                        </>
                                                        :
                                                        <div className='row mx-0 h-100'>
                                                            <div className='col-12 px-0 h-100 d-flex justify-content-center align-items-center'>
                                                                <span>
                                                                    {"No payment history"}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            }
                                        </div>
                                    </>
                                }

                                {/* If not have any of above permission */}
                                {!permissionArray.includes("SCAN TAB") && !permissionArray.includes("UPDATE WORK INFORMATION") &&
                                    <div className='row mx-0 h-100'>
                                        <div className='col-12 px-0 h-100 d-flex justify-content-center align-items-center'>
                                            <span>
                                                {"No payment history"}
                                            </span>
                                        </div>
                                    </div>
                                }
                            </>



                        </div>
                    </div>

                </Modal.Body>
            </Modal>


            {updateCardTrigger &&
                <UpdateCardDetails
                    updateCardTrigger={updateCardTrigger}
                    handleCloseUpdateCard={handleCloseUpdateCard}
                    particularCard={particularCard}
                />
            }
            {addNewCardTrigger &&
                <AddNewCard
                    addNewCardTrigger={addNewCardTrigger}
                    handleCloseAddNewCard={handleCloseAddNewCard}
                />
            }
            {deleteCardTrigger &&
                <DeleteCard
                    deleteCardTrigger={deleteCardTrigger}
                    handleCloseDeleteCard={handleCloseDeleteCard}
                    particularCard={particularCard}
                />
            }

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
            {/* {apiResponce && <ResponceForAPI show={apiResponce} />} */}
        </>
    );
}

export default SaveCardDetails;